import axios from '@/axios'
import api from '../api'
import qs from 'qs'

export const dpmmService = {
  fetchDocuments,
  fetchDocumentDownloadLink,
  fetchServiceLetters,
  fetchAvailableRegions,
  sendSubscriptions,
  getSubscriptions,
  reportError,
  fetchIdentity,
  fetchOrgDescendants
}

function fetchDocuments(_params) {
  return new Promise((resolve, reject) => {
    axios.get(api.endpoints.DPMM_API.SERVICE_LIBRARY_DOCUMENTS, {
      params: _params,
      paramsSerializer: params => qs.stringify(params, {arrayFormat: 'comma'})
    }).then(({data}) => {
      if (data.error) reject(data.error)
      resolve(data)
    }).catch(r => {
      reject(r.response ? r.response.data.error : {'code': '', 'message': r})
    })
  })
}

function fetchDocumentDownloadLink(_documentId) {
  return new Promise((resolve, reject) => {
    axios.get(api.endpoints.DPMM_API.SERVICE_LIBRARY_DOCUMENT_DOWNLOAD.replace('{document_id}', _documentId)).then(r => {
      resolve(r.data.download_link)
    }).catch(r => {
      reject(r.response ? r.response.data.error : {'code': '', 'message': r})
    })
  })
}

function fetchServiceLetters(_fieldModCode) {
  return new Promise((resolve, reject) => {
    axios.get(api.endpoints.DPMM_API.SERVICE_LIBRARY_LETTERS.replace('{field_mod_code}', _fieldModCode)).then(r => {
      if (r.data.error) reject(r.data.error)
      if (r.data && r.data.download_link) {
        resolve(r.data.download_link)
      } else {
        reject()
      }
    }).catch(r => {
      reject(r.response ? r.response.data.error : {'code': '', 'message': r})
    })
  })
}

function fetchAvailableRegions() {
  return axios.get(api.endpoints.DPMM_API.AVAILABLE_REGIONS)
}

function sendSubscriptions(_postParameters) {
  return axios.post(api.endpoints.DPMM_API.FEEDBACK_SUBSCRIPTIONS, _postParameters)
}
function getSubscriptions(region) {
  return axios.get(api.endpoints.DPMM_API.FEEDBACK_SUBSCRIPTIONS, {
    params: {business_unit: region.toUpperCase()}
  })
}

function reportError(formData) {
  return axios.post(api.endpoints.DPMM_API.SERVICE_LIBRARY_REPORT_ERROR, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

function fetchIdentity() {
  return axios.get(api.endpoints.DPMM_API.IDENTITY)
}

function fetchOrgDescendants() {
  return axios.get(api.endpoints.DPMM_API.ORG_DESCENDANTS)
}
